import React, { useState } from "react";
import cn from "classnames";
import { Icon } from "@wf/components";
import useScrollDirection, { SCROLL_DIRECTION } from "../../hooks/useScrollDirection";
import MainContainer from "../MainContainer";
import ItemsBlock from "./ItemsBlock";
import styles from "./NavBar.module.scss";

interface MenuItem {
    title: string;
    url?: string;
    isInternalLink?: boolean;
    target?: string;
    menu?: MenuItem[];
    id: string | number;
}

interface NavBarProps {
    menu: MenuItem[];
    handleLinkClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string, target?: string, isInternalLink?: boolean) => void;
}

const NavBar: React.FC<NavBarProps> = ({ menu, handleLinkClick }) => {
  const [activeBlock, setActiveBlock] = useState(null);

  const scrollDirection = useScrollDirection();

  // @ts-ignore
  const handleShowBlock = (el, block?: any) => {
    if (el.menu || block) {
      setActiveBlock(el);
    } else {
      setActiveBlock(null);
    }
  };

  return (
    <nav className={styles.navBar}>
      <ul
        className={styles.level1}
      >
        {menu.map(el => {
          let menuItem;
          // @ts-ignore
          const isActive = el?.title === activeBlock?.title;
          if (el.url) {
            menuItem = (
              <a
                itemProp="url"
                className={cn(styles.topLink, { [styles.isActive]: isActive })}
                href={el.url}
                target={el.target || "_self"}
              >
                <span itemProp="name">{el.title}</span>
              </a>
            );
          } else {
            menuItem = (
              <span className={cn(styles.topLink, { [styles.isActive]: isActive })}>
                <span>{el.title}</span>
                {/*  @ts-ignore */}
                <Icon className={styles.arrow} name={isActive ? "ic_arrow_up" : "ic_arrow_down"} size={10} />
              </span>
            );
          }
          return (
            <li
              className={styles.firstLevelLink}
              onMouseEnter={() => handleShowBlock(el)}
              onMouseLeave={() => {
                setActiveBlock(null);
              }}
              // @ts-ignore
              onClick={e => handleLinkClick(e, el.url, el.target, el.isInternalLink)}
              key={el?.id}
            >
              <div className={cn({ [styles.top]: isActive })} />
              {menuItem}
              <div className={cn({ [styles.border]: isActive })} />
            </li>
          );
        })}
      </ul>
      {menu.map(el =>
        el.menu ? (
          <div
            key={el.id ?? el.title}
            onMouseLeave={() => {
              setActiveBlock(null);
            }}
            onMouseEnter={() => handleShowBlock(el, true)}
            className={cn(styles.block, {
              [styles.navUp]: scrollDirection === SCROLL_DIRECTION.up,
              [styles.navDown]: scrollDirection === SCROLL_DIRECTION.down,
              //   @ts-ignore
              [styles.hide]: !activeBlock || activeBlock?.id !== el.id
            })}
          >
            <MainContainer className={styles.mainContent}>
              {/*  @ts-ignore */}
              <ItemsBlock items={el.menu} handleLinkClick={handleLinkClick} />
            </MainContainer>
          </div>
        ) : null
      )}
    </nav>
  );
};

export default NavBar;
